/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var PureRenderMixin, React, ReactDOM, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

css = require('../css/lobby.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  getDefaultProps: function() {},
  displayName: 'Lobby',
  getLabelForPlayer: function(player) {
    var labels;
    labels = [];
    if (player.master) {
      labels.push(React.createElement("span", {
        "key": "master",
        "className": "label label-primary"
      }, "Master"));
    }
    if (player.ready) {
      labels.push(React.createElement("span", {
        "key": "ready",
        "className": "label label-success"
      }, "Připraven"));
    } else {
      labels.push(React.createElement("span", {
        "key": "waiting",
        "className": "label label-danger"
      }, "Zdržuje"));
    }
    return labels;
  },
  handleReady: function() {
    this.props.actions.getReady(this.props.game.id);
  },
  isEveryoneReady: function() {
    return this.props.game.players.every(function(player) {
      return player.ready;
    });
  },
  handleStartGame: function() {
    if (this.props.game.players.length < 1) {
      alert('K zahájení hry jsou potřeba alespoň tři hráči.');
      return;
    }
    this.props.actions.startGame(this.props.game.id);
  },
  render: function() {
    var me, players, readyEl, startGameBtn;
    me = null;
    players = this.props.game.players.map((function(_this) {
      return function(player) {
        if (player.id === _this.props.user.data.id) {
          me = player;
        }
        return React.createElement("div", {
          "key": player.id,
          "className": css['player']
        }, React.createElement("span", {
          "className": css['player-name']
        }, player.nickname), _this.getLabelForPlayer(player));
      };
    })(this));
    if ((me != null ? me.master : void 0) && this.isEveryoneReady()) {
      startGameBtn = React.createElement("div", {
        "className": "btn btn-primary",
        "onClick": this.handleStartGame
      }, "Spustit hru");
    }
    if (!(me != null ? me.ready : void 0)) {
      readyEl = React.createElement("div", {
        "className": "btn btn-primary",
        "onClick": this.handleReady
      }, "Jsem připraven");
    }
    return React.createElement("div", {
      "className": css['lobby']
    }, React.createElement("h2", null, "Lobby : ", this.props.game.name), players, React.createElement("div", {
      "className": css['buttons']
    }, readyEl, startGameBtn));
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "lobby.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lobby.cjsx
 ** module id = 261
 ** module chunks = 0
 **/